import type React from "react";
import { cn } from "../../../utils/utils";
import { cva, type VariantProps } from "class-variance-authority";

const wrapperVariants = cva(
  "inline-flex relative justify-center items-center bg-white border border-black rounded-xl",
  {
    variants: {
      variant: {
        default: "bg-white text-black",
        primary: "bg-[#A6FF4D] text-black",
        secondary: "bg-white text-black",
      },
      size: {
        default: "p-4",
        sm: "p-2",
        lg: "p-6",
      },
      shadow: {
        default: "shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]",
        md: "shadow-[3px_3px_0px_0px_rgba(0,0,0,1)]",
        lg: "shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]",
      },
      hover: {
        true: "hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all duration-200",
        false: "",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      shadow: "default",
      hover: true,
    },
  }
);

export interface ThreeDWrapperProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof wrapperVariants> {
  children: React.ReactNode;
}

export function ThreeDWrapper({
  className,
  variant,
  size,
  shadow,
  hover,
  children,
  ...props
}: ThreeDWrapperProps) {
  return (
    <div
      className={cn(wrapperVariants({ variant, size, shadow, hover }), className)}
      {...props}
    >
      {children}
    </div>
  );
}
